<template>
  <div class="border-t">
    <draggable v-model="productList">
      <div v-for="product in products" :key="product.id" class="flex items-center px-4 py-2 border-0 border-b cursor-grab hover:bg-gray-50">
        <div class="pr-4 text-xs text-gray-400">
          <fa :icon="['fas', 'grip-vertical']" />
        </div>
        <div class="flex items-center space-x-4">
          <div class="flex items-center justify-center flex-none w-12 h-12 overflow-hidden border rounded bg-gray-50">
            <img v-if="product.image" :src="product.image" :alt="product.name" class="object-cover h-full">
            <fa v-else :icon="['far', 'cube']" class="text-lg text-gray-300" />
          </div>
          <div>
            <div class="flex items-center font-semibold">
              {{ product.name }}
            </div>
            <div class="text-gray-500">
              <currency :value="product.price" :currency-code="account.currency" :subunits-value="true" />
            </div>
          </div>
        </div>
        <div class="ml-auto text-right">
          <div v-if="product.status === 'active'">
            <badge class="text-green-800 bg-green-100">Active</badge>
          </div>
          <div v-else-if="product.status === 'draft'">
            <badge class="text-cyan-800 bg-cyan-100">Draft</badge>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'ProductSort',

  components: {
    draggable
  },

  props: {
    products: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapGetters(['account']),

    productList: {
      get () {
        return this.products
      },

      set (value) {
        this.$emit('update:products', value)
      }
    }
  }
}
</script>
